<template>
  <section class="customers-add">
    <h2 class="subtitle">{{ this.record.text }}</h2>
    <div v-html="this.record.content"></div>
  </section>
</template>
<script>
import { AuthService } from "@/services/AuthService";
import { mapGetters } from "vuex";
import DashboardDataService from "../../services/DashboardDataService";
// @group Customers
export default {
  name: "CustomerAddViewComponent",
  props: {
    isAction: {
      type: String,
      default: null
    }
  },
  components: {},
  data() {
    return {
      authService: new AuthService(),
      dashboardDataService: new DashboardDataService(),
      record: null
    };
  },
  computed: {
    ...mapGetters(["userId", "userName", "userHasPermission", "userGroups"])
  },
  mounted() {
    this.fetchUpdate();
  },
  methods: {
    fetchUpdate() {
      const updateListObserve = this.dashboardDataService.getUpdateById(
        this.$route.params.id
      );
      updateListObserve.subscribe(
        response => {
          this.record = response;
        },
        e => {
          console.log(e);
        }
      );
      return updateListObserve;
    }
  }
};
</script>
